import InfoPanel from "lib/ui/info-panel/info-panel";
import PropTypes from "prop-types";
import React from "react";

const MeterReadings = ({ meter }) => {
  const meterReadings = meter.meterReadings;

  const renderConnectActionLoad = () => {
    return (
      <div key="connecting" className="flex items-center justify-center my-10">
        <span className="fa-2x mr-3">
          <i className="fa fa-circle-notch fa-pulse text-blue-500" />
        </span>
        <span>Connecting...</span>
      </div>
    );
  };

  const renderReadings = () => {
    return meterReadings.map((reading, index) => {
      return (
        <div key={index}>
          {`${reading.date}, 5:55 - 6:20, ${reading.pulseCount} pulses`}
        </div>
      );
    });
  };

  const meterConnectAction = {
    text: "Connect",
    icon: "fa-wifi",
    renderPanel: renderConnectActionLoad()
  };

  if (!meterReadings || meterReadings.length === 0) {
    return <InfoPanel title="Readings" summary="No readings found" />;
  }

  return (
    <InfoPanel
      title="Readings"
      summary={renderReadings()}
      action={meterConnectAction}
    />
  );
};

MeterReadings.propTypes = {
  meter: PropTypes.object
};

export default MeterReadings;
